class CartTracking {
  init() {
    this.cartEvents();
  }

  cartEvents() {
    document.addEventListener('persistence-cart:updated', (event) => {
      if ((event.detail.added.length > 0 || event.detail.removed.length > 0) && window._learnq) {
        const cartItems = [];
        let checkoutUrl = `${window.location.origin}/cart/`;
        event.detail.cart?.items.forEach((item) => {
          if (item.variant_id && item.quantity && item.final_price > 0) {
            cartItems.push({
              title: item.title,
              id: item.id,
              variant_id: item.variant_id,
              quantity: item.quantity,
              image: item.image,
            });
            checkoutUrl += `${item.variant_id}:${item.quantity},`;
          }
        });
        window._learnq.push(['track', 'Custom Added to Cart', {
          items: cartItems,
          url: checkoutUrl,
        }]);
      }
    });
  }
}
const myCartTracking = new CartTracking();
myCartTracking.init();
